import React from 'react';
import { motion } from 'framer-motion';
import { LightbulbIcon, ClipboardCheck, TrendingUp, Users } from 'lucide-react';
import Container from '../../layout/Container';
import SectionHeading from '../../common/SectionHeading';
import Card from '../../common/Card';

const consultationServices = [
  {
    icon: LightbulbIcon,
    title: 'IT Strategy Development',
    description: 'Creating comprehensive IT strategies aligned with your business goals and market demands.',
  },
  {
    icon: ClipboardCheck,
    title: 'Technology Assessment',
    description: 'Evaluating your current IT infrastructure to identify strengths, weaknesses, and opportunities for improvement.',
  },
  {
    icon: TrendingUp,
    title: 'Performance Optimization',
    description: 'Enhancing the efficiency and effectiveness of your IT systems to maximize performance and ROI.',
  },
  {
    icon: Users,
    title: 'Training & Knowledge Transfer',
    description: 'Equipping your team with the skills and knowledge needed to leverage your technology investments.',
  },
];

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
    },
  },
};

const item = {
  hidden: { opacity: 0, y: 20 },
  show: { opacity: 1, y: 0, transition: { duration: 0.5 } },
};

const ConsultationServices = () => {
  return (
    <section className="py-20 bg-gray-50">
      <Container>
        <SectionHeading
          title="Technical Consultation Services"
          subtitle="Expert guidance to help you make informed technology decisions."
          center
        />
        
        <motion.div
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-12"
        >
          {consultationServices.map((service, index) => (
            <motion.div key={index} variants={item}>
              <Card
                icon={service.icon}
                title={service.title}
                description={service.description}
                hover
                className="h-full"
              />
            </motion.div>
          ))}
        </motion.div>
        
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.4 }}
          viewport={{ once: true }}
          className="mt-16 text-center"
        >
          <p className="text-gray-700 max-w-3xl mx-auto">
            Our consultation services are delivered by certified professionals with deep industry knowledge 
            and technical expertise. We take a collaborative approach, working closely with your team to 
            understand your requirements and develop tailored solutions that address your specific challenges.
          </p>
        </motion.div>
      </Container>
    </section>
  );
};

export default ConsultationServices;